export default __webpack_public_path__ + "static/media/scala.720a65cf.png";